import { FormApi } from 'final-form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { MediaField } from '~admin/view/components/ui/form/fields/field-media.component';
import { MediaType } from '~client/model/media-type';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

export interface EventMediaFormData {
  avatarMedia: MediaData;
  defaultMedia: MediaData;
  emailMedia: MediaData;
  landscapeVideo: MediaData;
  portraitVideo?: MediaData;
}

interface Props {
  form: FormApi<EventFormData>;
}

export const EventMediaDetails: React.FunctionComponent<Props> = ({ form }) => {
  const { t } = useTranslation();
  const submitFailed = form.getState().submitFailed;

  return (
    <Container>
      <WrapRow>
        <MediaField
          name={'avatarMedia'}
          label={t('createEvent.eventDetails.media.avatarMedia')}
          mediaType={MediaType.IMAGE}
          onMediaSelected={(media: MediaData | null): void => {
            form.change('avatarMedia', media);
          }}
          submitFailed={submitFailed}
        />
        <MediaField
          name={'defaultMedia'}
          label={t('createEvent.eventDetails.media.defaultMedia')}
          mediaType={MediaType.IMAGE}
          onMediaSelected={(media: MediaData | null): void => {
            form.change('defaultMedia', media);
          }}
          submitFailed={submitFailed}
        />
        <MediaField
          name={'emailMedia'}
          label={t('createEvent.eventDetails.media.emailMedia')}
          mediaType={MediaType.IMAGE}
          onMediaSelected={(media: MediaData | null): void => {
            form.change('emailMedia', media);
          }}
          submitFailed={submitFailed}
        />
        <MediaField
          name={'landscapeVideo'}
          label={t('createEvent.eventDetails.media.landscapeVideo')}
          mediaType={MediaType.VIDEO}
          onMediaSelected={(media: MediaData | null): void => {
            form.change('landscapeVideo', media);
          }}
          submitFailed={submitFailed}
        />
        <MediaField
          name={'portraitVideo'}
          label={t('createEvent.eventDetails.media.portraitVideo')}
          mediaType={MediaType.VIDEO}
          onMediaSelected={(media: MediaData | null): void => {
            form.change('portraitVideo', media);
          }}
        />
      </WrapRow>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;

const WrapRow = styled(Box)`
  flex-wrap: wrap;
  justify-content: space-evenly;

  > div {
    margin: 12px 24px 0;
  }
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-media-details.component.tsx